import { setDirectConsolePrinter } from './config';
import { withConsentEnhancer } from './consent';
import { loggerCore } from './core';
import {
  createUserEnhancer,
  createTenantEnhancer,
  buildMetadataEnhancer,
  buildUrlEnhancer,
} from './enhancers';
import { logger } from './index';
import { ConsolePlugin } from './plugins/console';
import { PostHogPlugin } from './plugins/posthog';
import { SentryPlugin } from './plugins/sentry';
import { interceptConsole } from './utils';

let essentialDone = false;

/**
 * Phase 1 — call as early as possible, before any provider context.
 * Registers console output and metadata; intercepts console methods.
 * Safe to call outside ConsentProvider / AuthProvider.
 */
export const initLoggingEssential = (
  opts: { directConsolePrinter?: boolean } = {},
): void => {
  if (essentialDone) return;
  essentialDone = true;

  if (opts.directConsolePrinter !== undefined) {
    setDirectConsolePrinter(opts.directConsolePrinter);
  }

  logger.useEnhancer(buildMetadataEnhancer);
  logger.useEnhancer(buildUrlEnhancer);
  logger.usePlugin(ConsolePlugin);
  interceptConsole();
};

let enhancedDone = false;

let _user: { id: string; email?: string } | undefined;
let _tenantId: string | undefined;

/** Called by useLoggerUserSync whenever auth state changes. */
export function setLoggerUser(user: typeof _user): void {
  _user = user;
  if (user) loggerCore.setUser(user);
}

/** Called by LoggingBootstrap with the tenant derived from the host. */
export function setLoggerTenant(tenantId: typeof _tenantId): void {
  _tenantId = tenantId;
}
export const initLoggingEnhanced = (): void => {
  if (enhancedDone) return;
  enhancedDone = true;

  logger.useEnhancer(withConsentEnhancer(createUserEnhancer(() => _user)));
  logger.useEnhancer(createTenantEnhancer(() => _tenantId));

  if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    logger.usePlugin(PostHogPlugin);
  }

  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    logger.usePlugin(SentryPlugin);
  }
};
